import { render, staticRenderFns } from "./commentReply.vue?vue&type=template&id=333f5dc4&scoped=true"
import script from "./commentReply.vue?vue&type=script&lang=js"
export * from "./commentReply.vue?vue&type=script&lang=js"
import style0 from "./commentReply.vue?vue&type=style&index=0&id=333f5dc4&prod&scoped=true&lang=css"
import style1 from "./commentReply.vue?vue&type=style&index=1&id=333f5dc4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "333f5dc4",
  null
  
)

export default component.exports